export default __webpack_public_path__ + "static/botanic-full-logo-c9887df0fb7fd78620e4786f2098347c.png";